import { AbstractControl, ValidationErrors } from "@angular/forms";

export function DateRangeRequiredValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value?.from && control.value?.to) {
    return null;
  }
  return { required: true };
}
